<template>
  <p-layout v-bind="$props">
    <template slot="body">
      <slot />
    </template>
  </p-layout>
</template>


<script>
export default {
  props: {
    loading: {
      default: false,
      type: Boolean
    },
    fluid: {
      default: false,
      type: Boolean
    }
  }
};
</script>
